import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'unr-hamburger-icon',
  templateUrl: 'hamburger.component.html',
  styleUrls: [
    'hamburger.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnrHamburgerComponent {
  @Input() open = false;
  @Input() darkTheme = true;
}
